import { signIn } from 'next-auth/react';
import { defaultLocale } from '~/locale/defaults';
import getLocale from '~/locale/get-locale';
import getRuntimeConfig from '~/services/runtime-config.service';
import { urlWithBasePath } from '~/utils/url-helpers';
import storageHelpers from '~/utils/storage-helpers';
import { FEEDBACK_CALLOUT_DISMISSED_KEY } from '~/constants';

export function cxpSignIn(
    callbackUrl: string,
    locale?: string,
    ssoToken?: string,
    provider = 'public-secure'
) {
    const selectedLocale = locale ?? getLocale() ?? defaultLocale;
    const resolvedCallbackUrl = urlWithBasePath(callbackUrl);

    if (provider === 'public-secure') {
        signIn(
            provider,
            {
                callbackUrl: resolvedCallbackUrl,
            },
            {
                lang: selectedLocale,
            }
        );
    } else if (provider === 'credentials') {
        signIn('credentials', {
            redirect: true,
            ssoToken: ssoToken, // Pass the sso token to the Credentials provider
            callbackUrl: resolvedCallbackUrl,
        });
    }
}

export async function cxpSignOut(idToken: string) {
    storageHelpers.removeSessionStorageItem(FEEDBACK_CALLOUT_DISMISSED_KEY);

    // do not call signout from next auth as it will will be done in the return flow from the public secure
    const config = await getRuntimeConfig();
    const logoutUrl = `${config.publicSecureIssuer}/v1/logout?${new URLSearchParams({
        id_token_hint: idToken,
        post_logout_redirect_uri: `${config.publicSecureSignoutRedirectUri}`,
    })}`;

    window.location.href = logoutUrl;
}
